import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid bg-dark text-light" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-10 py-4 panel-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PanelSidebarComponent = _resolveComponent("PanelSidebarComponent")!
  const _component_DashboardComponent = _resolveComponent("DashboardComponent")!
  const _component_StaffTableComponent = _resolveComponent("StaffTableComponent")!
  const _component_TicketsTableComponent = _resolveComponent("TicketsTableComponent")!
  const _component_UserLeaderboardComponent = _resolveComponent("UserLeaderboardComponent")!
  const _component_TokenManagerComponent = _resolveComponent("TokenManagerComponent")!
  const _component_ConfigManagerComponent = _resolveComponent("ConfigManagerComponent")!
  const _component_PenaltyBlockManagerComponent = _resolveComponent("PenaltyBlockManagerComponent")!
  const _component_ReportSettingsComponent = _resolveComponent("ReportSettingsComponent")!
  const _component_ClassifierComponent = _resolveComponent("ClassifierComponent")!
  const _component_IncidentLogComponent = _resolveComponent("IncidentLogComponent")!
  const _component_IncidentDetailView = _resolveComponent("IncidentDetailView")!
  const _component_StaffAssistantWidget = _resolveComponent("StaffAssistantWidget")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_PanelSidebarComponent, {
        onNavigate: _cache[0] || (_cache[0] = ($event: any) => (_ctx.currentSection = $event))
      }),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.currentSection === 'dashboard')
          ? (_openBlock(), _createBlock(_component_DashboardComponent, { key: 0 }))
          : _createCommentVNode("", true),
        (_ctx.currentSection === 'staff')
          ? (_openBlock(), _createBlock(_component_StaffTableComponent, {
              key: 1,
              user: _ctx.user
            }, null, 8, ["user"]))
          : _createCommentVNode("", true),
        (_ctx.currentSection === 'tickets')
          ? (_openBlock(), _createBlock(_component_TicketsTableComponent, {
              key: 2,
              user: _ctx.user,
              "groups-map": _ctx.groupsMap,
              lang: _ctx.lang
            }, null, 8, ["user", "groups-map", "lang"]))
          : _createCommentVNode("", true),
        (_ctx.currentSection === 'users')
          ? (_openBlock(), _createBlock(_component_UserLeaderboardComponent, { key: 3 }))
          : _createCommentVNode("", true),
        (_ctx.currentSection === 'tokens')
          ? (_openBlock(), _createBlock(_component_TokenManagerComponent, {
              key: 4,
              user: _ctx.user
            }, null, 8, ["user"]))
          : _createCommentVNode("", true),
        (_ctx.currentSection === 'config')
          ? (_openBlock(), _createBlock(_component_ConfigManagerComponent, { key: 5 }))
          : _createCommentVNode("", true),
        (_ctx.currentSection === 'penalty-blocks')
          ? (_openBlock(), _createBlock(_component_PenaltyBlockManagerComponent, { key: 6 }))
          : _createCommentVNode("", true),
        (_ctx.currentSection === 'report-settings')
          ? (_openBlock(), _createBlock(_component_ReportSettingsComponent, { key: 7 }))
          : _createCommentVNode("", true),
        (_ctx.currentSection === 'classifier')
          ? (_openBlock(), _createBlock(_component_ClassifierComponent, { key: 8 }))
          : _createCommentVNode("", true),
        (_ctx.currentSection === 'incidents' && !_ctx.selectedIncident)
          ? (_openBlock(), _createBlock(_component_IncidentLogComponent, { key: 9 }))
          : _createCommentVNode("", true),
        (_ctx.currentSection === 'incidents' && _ctx.selectedIncident)
          ? (_openBlock(), _createBlock(_component_IncidentDetailView, {
              key: 10,
              incident: _ctx.selectedIncident,
              onBack: _ctx.closeIncidentDetail
            }, null, 8, ["incident", "onBack"]))
          : _createCommentVNode("", true),
        _createVNode(_component_StaffAssistantWidget)
      ])
    ])
  ]))
}